import { Color, SkeletonText, Space, Text } from '@billy/design-system'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import * as Styled from './styles'

export interface TaxDisplayProps {
  amount: number
  period?: string
  userHasToPayTax: boolean
  isLoading?: boolean
}

export const TaxDisplay = ({ amount, period, isLoading }: TaxDisplayProps) => {
  const { t } = useTranslation()

  const { organization } = useUserOrganization()

  const hasToPayTax = amount && amount > 0

  return (
    <Styled.Container>
      <>
        {isLoading ? (
          <SkeletonText width={100} variant="h1" />
        ) : (
          <>
            <Text colorVariant="secondary" variant="bodySM">
              {t('dashboard.widget.vat.amount_info')}
            </Text>
            <Space size="s8" />
            <Styled.AmountValue
              amount={Math.abs(amount)}
              currencyId={organization?.baseCurrencyId}
              textVariant="h1"
              color={hasToPayTax ? Color.Red700 : Color.Green400}
            />

            {period && (
              <>
                <Text weight="regular" colorVariant="secondary" variant="bodySM">
                  {`${t('dashboard.widget.vat.period')}: ${period}`}
                </Text>
                <Space size="s8" />
              </>
            )}
          </>
        )}
      </>
    </Styled.Container>
  )
}
